import http from 'plugins/axios';

export default {
    getUserProfitList(data) {
        return http.get({
            url: '/admin/etp/userProfitList',
            data
        });
    },
    getUserProfitDetail(data) {
        return http.get({
            url: '/admin/etp/userProfitDetail',
            data
        });
    },
};
